/**
* 测量点命令控制
*/
const command = {

  executeCommandOnMeasure: "/api/executeCommandOnMeasure",//执行指令
  getRecentHistoryOfMeasureCommandExecuting: '/api/getRecentHistoryOfMeasureCommandExecuting',//查询指令执行历史
}

export default command